import { $, $$ } from 'src/shared/js/utils/dom';
import Shower from 'src/shared/js/modules/shower';

class Header {
  constructor(params) {
    this.header = params.header;
    this.breakpoint = params.breakpoint;
    this.firstLevel = null;
    this.firstLevelInitiated = false;
    this.secondLevel = null;
    this.secondLevelInitiated = false;
    this.secondLevels = [];
    this.thirdLevel = null;
    this.thirdLevelInitiated = false;
    this.thirdLevels = [];
    this.searchMobile = null;
    this.searchMobileInitiated = false;
    this.searchDesktop = null;
    this.searchDesktopInitiated = false;
  }

  initFirstLevel = () => {
    if (window.innerWidth <= this.breakpoint && !this.firstLevelInitiated) {
      const button = $('.header__buttons .btn--burger', header);
      const navigation = $('.header__navigation', header);

      if (button && navigation) {
        this.firstLevel = new Shower({
          target: navigation,
          handler: button,
          easing: 'easeInOutCubic',
          duration: 400,
          openClassName: 'is-active',
        });
        this.firstLevel.init();
        this.firstLevelInitiated = true;

        const isSearchActive = () => {
          if (this.searchMobileInitiated && this.searchMobile.show) {
            this.searchMobile.close();
          }
        };

        this.firstLevel.handler.addEventListener('click', isSearchActive);
      }
    }
  };

  initSecondLevel = () => {
    if (window.innerWidth <= this.breakpoint && !this.secondLevelInitiated) {
      const navItem = $$('.navigation__level-1-item', header);

      if (navItem.length) {
        navItem.forEach(item => {
          const openSecondLevelButton = $('.navigation__level-1-button', item);

          if (openSecondLevelButton) {
            const secondLevel = new Shower({
              target: $('.navigation__level-2-wrapper', item),
              handler: openSecondLevelButton,
              easing: 'easeInOutExpo',
              duration: 400,
              openClassName: 'is-active',
            });

            this.secondLevels.push(secondLevel);
          }
        });

        this.secondLevels.forEach(shower => {
          shower.init();
        });
        this.secondLevelInitiated = true;
      }
    }
  };

  initThirdLevel = () => {
    if (!this.thirdLevelInitiated) {
      const navItem = $$('.navigation__level-2-item', header);

      if (navItem.length) {
        navItem.forEach(item => {
          const openThirdLevelButton = $('.navigation__level-2-button', item);

          if (openThirdLevelButton) {
            const thirdLevel = new Shower({
              target: $('.navigation__level-3-wrapper', item),
              handler: openThirdLevelButton,
              easing: 'easeInOutExpo',
              duration: 400,
              openClassName: 'is-active',
            });

            this.thirdLevels.push(thirdLevel);
          }
        });

        this.thirdLevels.forEach(shower => {
          shower.init();
        });
        this.thirdLevelInitiated = true;
      }
    }
  };

  initSearchMobile = () => {
    if (window.innerWidth <= this.breakpoint && !this.searchMobileInitiated) {
      const button = $('.header__search-button-mobile', header);
      const search = $('.header__search', header);

      if (button && search) {
        this.searchMobile = new Shower({
          target: search,
          handler: button,
          easing: 'easeInOutCubic',
          duration: 400,
          openClassName: 'is-active',
        });
        this.searchMobile.init();
        this.searchMobileInitiated = true;

        const isFirstLevelActive = () => {
          if (this.firstLevelInitiated && this.firstLevel.show) {
            this.firstLevel.close();
          }
        };
        this.searchMobile.handler.addEventListener('click', isFirstLevelActive);
      }
    }
  };

  initSearchDesktop = () => {
    if (window.innerWidth >= this.breakpoint && !this.searchDesktopInitiated) {
      const button = $('.header__search-button-desktop', header);
      const search = $('.header__search', header);

      if (button && search) {
        this.searchDesktop = new Shower({
          target: search,
          handler: button,
          easing: 'easeInOutCubic',
          duration: 400,
          openClassName: 'is-active',
        });

        this.searchDesktop.init();
        this.searchDesktopInitiated = true;

        button.addEventListener(
          'click',
          function () {
            if (!this.searchDesktopInitiated) {
              $('#searchbar__input--header').focus();
            } else {
              $('#searchbar__input--header').blur();
            }
          },
          false
        );
      }
    }
  };

  handleResize = () => {
    if (window.innerWidth <= this.breakpoint) {
      if (!this.firstLevelInitiated) {
        this.initFirstLevel();
        this.firstLevelInitiated = true;
      }
      if (!this.secondLevelInitiated) {
        this.initSecondLevel();
        this.secondLevelInitiated = true;
      }

      if (this.searchDesktopInitiated) {
        this.searchDesktop.destroy();
        this.searchDesktopInitiated = false;
      }

      if (!this.searchMobileInitiated) {
        this.initSearchMobile();
        this.searchMobileInitiated = true;
      }
    }
    if (window.innerWidth >= this.breakpoint) {
      if (this.firstLevelInitiated) {
        this.firstLevel.destroy();
        this.firstLevelInitiated = false;
        this.firstLevel = null;
      }
      if (this.secondLevelInitiated) {
        this.secondLevels.forEach(level => {
          level && level.destroy();
        });

        this.secondLevelInitiated = false;
        this.secondLevels = [];
      }

      if (this.searchMobileInitiated) {
        this.searchMobile.destroy();
        this.searchMobileInitiated = false;
      }

      if (!this.searchDesktopInitiated) {
        this.initSearchDesktop();
        this.searchDesktopInitiated = true;
      }
    }
  };

  bindEvents = () => {
    window.addEventListener('resize', () => this.handleResize());
  };

  init = () => {
    this.bindEvents();
    this.initFirstLevel();
    this.initSecondLevel();
    this.initThirdLevel();
    this.initSearchMobile();
    this.initSearchDesktop();
  };
}

const header = $('.header');

if (header) {
  new Header({
    header,
    breakpoint: 1199,
  }).init();

  function getNextFocusableElement(currentItem) {
    const focusableElements = Array.from(
      document.querySelectorAll(
        "a[href], button, input, select, textarea, [tabindex]:not([tabindex='-1'])"
      )
    ).filter(element => !element.closest('.header__search'));

    const currentIndex = focusableElements.indexOf(currentItem);
    const nextIndex = currentIndex === -1 ? 0 : currentIndex + 1;

    return focusableElements[nextIndex] || focusableElements[0];
  }

  const menuList = $('.navigation__level-1');
  if (menuList) {
    const lastMenuItem = menuList.lastElementChild;
    if (lastMenuItem) {
      const metaMenu = $$('.navigation__meta-link, .header__search-button-desktop');
      const reversedMetaItems = Array.from(metaMenu).reverse();
      const nextFocusElement = getNextFocusableElement(reversedMetaItems[0]);

      lastMenuItem?.addEventListener('keydown', event => {
        if (event.key === 'Tab') {
          event.preventDefault();
          reversedMetaItems[0].focus();

          reversedMetaItems.forEach((currentItem, i) => {
            const nextItem = i + 1;

            currentItem.addEventListener('keydown', event => {
              if (event.key === 'Tab') {
                event.preventDefault();
                const nextElement = reversedMetaItems[nextItem] || nextFocusElement;
                nextElement.focus();
              }
            });
          });
        }
      });
    }
  }

  const topLevelLinks = document.querySelectorAll(
    '.navigation__main .navigation__level-1-link'
  );

  const subMenus = document.querySelectorAll(
    '.navigation__main .navigation__level-2-wrapper'
  );

  topLevelLinks.forEach(link => {
    if (link.nextElementSibling) {
      link.addEventListener('focus', function () {
        this.parentElement.classList.add('focus');
      });

      link.parentElement.addEventListener('mouseover', function () {
        link.parentElement.classList.add('hovered');
      });

      link.parentElement.addEventListener('mouseout', function () {
        link.parentElement.classList.remove('hovered');
      });

      const subMenu = link.parentElement.getElementsByClassName(
        'navigation__level-2-wrapper'
      )[0];
      const subMenuLinks = subMenu.querySelectorAll(
        'a.navigation__level-2-link'
      );
      const lastLinkIndex = subMenuLinks.length - 1;
      const lastLink = subMenuLinks[lastLinkIndex];

      lastLink.classList.add('last');

      lastLink.addEventListener('blur', function () {
        link.parentElement.classList.remove('focus');
      });

      document
        .getElementsByClassName('navigation__main')[0]
        .addEventListener('keydown', evt => {
          if (evt.key === 'Escape') {
            evt.preventDefault();
            link.parentElement.classList.remove('hovered');
          }
        });
    }
  });

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.keyCode === 27) {
      subMenus.forEach(sub => {
        evt.preventDefault();
        sub.parentElement.classList.remove('hovered');
        sub.parentElement.classList.remove('focus');
      });
    }
  };
}
